import i18n from "@/plugins/i18n";
import datasetGiftStatus from "@/datasets/giftStatus";
import datasetGender from "@/datasets/gender";
import datasetRace from "@/datasets/race";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Delivery Status",
          value: "status",
        },
        {
          text: "Mochi Id",
          value: "mochiId",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Classroom",
          value: "classroomName",
        },
        {
          text: "Institution",
          value: "institutionName",
        },
        {
          text: "Town",
          value: "town",
        },
        {
          text: "State",
          value: "state",
        },
        {
          text: "Delivery Status",
          value: "status",
        },
        {
          text: "Mochi Id",
          value: "mochiId",
        },
        {
          text: "Gender",
          value: "gender",
        },
        {
          text: "Race",
          value: "race",
        },
        {
          text: "MOE Number",
          value: "moeNumber",
        },
        {
          text: "Email Address",
          value: "email",
        },
        {
          text: "Mochi Id",
          value: "mochiId",
        },
        {
          text: "Gift Sent Date",
          value: "timestampGiftSent",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "string",
        key: "name",
        name: "Name",
      },
      {
        type: "string",
        key: "moeNumber",
        name: "NRIC/Passport Number",
      },
      {
        type: "string",
        key: "email",
        name: "Email Address (MOE Email)",
      },
      {
        type: "string",
        key: "institutionName",
        name: "Institution Name",
      },
      {
        type: "string",
        key: "classroomName",
        name: "Classroom Name",
      },
      {
        type: "model",
        key: "state",
        name: "State",
        model: "state",
        optionText: "name",
        server: "sso",
        optionValue: "value",
        defaultValue: 1,
      },
      {
        type: "string",
        key: "town",
        name: "Town",
      },
      {
        type: "select",
        key: "gender",
        name: "Gender",
        options: datasetGender,
        optionText: "name",
        optionValue: "value",
        defaultValue: null,
      },
      {
        type: "string",
        key: "originalGender",
        name: "Original Gender",
      },
      {
        type: "select",
        key: "race",
        name: "Race",
        options: datasetRace,
        optionText: "name",
        optionValue: "value",
        defaultValue: null,
      },
      {
        type: "string",
        key: "originalRace",
        name: "Original Race",
      },
      {
        type: "select",
        key: "status",
        name: "Delivery Status",
        options: datasetGiftStatus,
        optionText: "name",
        optionValue: "value",
        defaultValue: "pending",
      },
    ],
    rules: false,
  },
  edit: true,
  delete: true,
};
